import {Action} from '@ngrx/store';
import {type} from '../../shared';

export const timezoneCultureTypes = {
  LOAD: type('[Timezone Culture] Load'),
  LOAD_FULL: type('[Timezone Culture FULL] Load'),
  LOAD_SUCCESS: type('[Timezone Culture] Load Success'),
  LOAD_FAIL: type('[Timezone Culture] Load Fail'),
};

export class LoadTimezoneCultureAction implements Action {
  readonly type = timezoneCultureTypes.LOAD;
  constructor(public payload?: string) {}
}
export class LoadTimezoneFullCultureAction implements Action {
  readonly type = timezoneCultureTypes.LOAD_FULL;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class LoadTimezoneCultureSuccessAction implements Action {
  readonly type = timezoneCultureTypes.LOAD_SUCCESS;
  constructor() {}
}

export class LoadTimezoneCultureFailAction implements Action {
  readonly type = timezoneCultureTypes.LOAD_FAIL;
  constructor(public payload?: number) {}
}

